import { MapPin, Phone, Clock, Facebook, Instagram } from "lucide-react";
import { LOGO_URL, CONTACT, CALL_LINK, WHATSAPP_LINK, SOCIAL } from "../data";
import { WhatsAppIcon } from "./WhatsAppIcon";

const LINKS = [
  { label: "Especialidades", href: "#especialidades" },
  { label: "Menú", href: "#menu" },
  { label: "Galería", href: "#galeria" },
  { label: "Nosotros", href: "#nosotros" },
  { label: "Ubicación", href: "#ubicacion" },
];

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-brand-ink border-t border-brand-gold/15 pt-16 pb-8"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3">
              <img
                src={LOGO_URL}
                alt="La Herencia Castañón"
                className="h-14 w-14 object-cover rounded-full ring-1 ring-brand-gold/40 bg-white"
              />
              <span className="font-display text-brand-cream leading-tight">
                <span className="block text-brand-gold text-sm italic">
                  La Herencia
                </span>
                <span className="block text-xl font-bold tracking-wide -mt-1">
                  CASTAÑÓN
                </span>
              </span>
            </div>
            <p className="mt-5 text-brand-sand text-sm max-w-sm leading-relaxed">
              Barbacoa tradicional &amp; al chipotle, 100% de res. Una herencia
              familiar que se sirve con orgullo en La Junta, Chihuahua.
            </p>
            <div className="flex gap-3 mt-6">
              <a
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                className="w-10 h-10 flex items-center justify-center border border-brand-gold/30 text-brand-gold hover:bg-brand-gold hover:text-brand-base transition-colors"
              >
                <WhatsAppIcon className="w-5 h-5" />
              </a>
              <a
                href={CALL_LINK}
                aria-label="Llamar"
                className="w-10 h-10 flex items-center justify-center border border-brand-gold/30 text-brand-gold hover:bg-brand-gold hover:text-brand-base transition-colors"
              >
                <Phone className="w-5 h-5" />
              </a>
              <a
                href={SOCIAL.facebook}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                data-testid="footer-facebook"
                className="w-10 h-10 flex items-center justify-center border border-brand-gold/30 text-brand-gold hover:bg-brand-gold hover:text-brand-base transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href={SOCIAL.instagram}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                data-testid="footer-instagram"
                className="w-10 h-10 flex items-center justify-center border border-brand-gold/30 text-brand-gold hover:bg-brand-gold hover:text-brand-base transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-display text-lg font-bold text-brand-cream mb-4">
              Navegación
            </h4>
            <ul className="space-y-2.5">
              {LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-sm text-brand-sand hover:text-brand-gold transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-lg font-bold text-brand-cream mb-4">
              Contacto
            </h4>
            <ul className="space-y-3 text-sm text-brand-sand">
              <li className="flex gap-2.5">
                <MapPin className="w-4 h-4 text-brand-gold shrink-0 mt-0.5" />
                {CONTACT.address}
              </li>
              <li className="flex gap-2.5">
                <Phone className="w-4 h-4 text-brand-gold shrink-0 mt-0.5" />
                <a href={CALL_LINK} className="hover:text-brand-gold transition-colors">
                  {CONTACT.phoneDisplay}
                </a>
              </li>
              <li className="flex gap-2.5">
                <Clock className="w-4 h-4 text-brand-gold shrink-0 mt-0.5" />
                Jue–Dom 7am–2pm · Lun 8am–1pm
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-brand-gold/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-brand-sand/60">
            © {new Date().getFullYear()} La Herencia Castañón. Todos los derechos
            reservados.
          </p>
          <p className="text-xs text-brand-sand/60 uppercase tracking-[0.2em]">
            Barbacoa tradicional &amp; al chipotle
          </p>
        </div>
      </div>
    </footer>
  );
};
